export default "__VITE_ASSET__UAFGJINK__"